import {SET_STAMP_CARDS} from "./StampCardsTypes";
import TransformShop from "../../transforms/TransformShop";

export function stampCardsReducer(state = [], action) {
    switch (action.type) {
        case SET_STAMP_CARDS:
            // console.log(action)
            if (!Array.isArray(action.data)) return [];
            return action.data.map((i) => TransformShop.toStampCard(i));
        default:
            return state;
    }
}
